import React from 'react'
import MobPatAppointmentsWrapper from './Mobile/components/MobPatAppointmentsWapper'

const PatAppointments = () => {
  return <MobPatAppointmentsWrapper />
}

export default PatAppointments
